// extracted by mini-css-extract-plugin
export var actionBtns = "meal-planer-templates-module--action-btns--tovLF";
export var actions = "meal-planer-templates-module--actions--UJwEW";
export var createOrEdit = "meal-planer-templates-module--createOrEdit--DGOCf";
export var holder = "meal-planer-templates-module--holder--SlplR";
export var loader = "meal-planer-templates-module--loader--KjK50";
export var planer = "meal-planer-templates-module--planer---D8Vy";
export var title = "meal-planer-templates-module--title--tDrCJ";
export var wrapper = "meal-planer-templates-module--wrapper--9dqrN";